import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import Layout from '../components/Layout';
import Header from '../components/Header';
import Binder from '../components/Binder';
import './SetListingsPage.css';
import { LoadingContext } from '../App';

const SetListingsPage = () => {
    const { setName: slug } = useParams();
    const [originalSetName, setOriginalSetName] = useState('');
    const [setDetails, setSetDetails] = useState(null);
    const [listings, setListings] = useState([]);
    const [page, setPage] = useState(1);
    const [error, setError] = useState(null);
    const { setLoading } = useContext(LoadingContext);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    useEffect(() => {
        const fetchSetDetails = async () => {
            setLoading(true);
            try {
                const response = await fetch(`${apiBaseUrl}/sets`);
                if (!response.ok) throw new Error(`Network error: ${response.statusText}`);
                const sets = await response.json();
                // Find the set that matches our slug
                const set = sets.find(s => {
                    const setSlug = s.name.toLowerCase()
                        .replace(/[^a-z0-9]+/g, '-')
                        .replace(/(^-|-$)/g, '');
                    return setSlug === slug;
                });
                if (set) {
                    setOriginalSetName(set.name);
                    setSetDetails(set);
                } else {
                    setError('Set not found');
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchSetDetails();
    }, [slug]);

    useEffect(() => {
        const fetchListings = async () => {
            if (!originalSetName) return;
            
            try {
                const response = await fetch(`${apiBaseUrl}/listings?set=${encodeURIComponent(originalSetName)}&page=${page}`);
                if (!response.ok) throw new Error(`Network error: ${response.statusText}`);
                const data = await response.json();
                setListings(data.listings || []);
            } catch (err) {
                setError(err.message);
            }
        };

        fetchListings();
    }, [originalSetName, page]);

    if (!slug) return <p>No set name provided</p>;
    if (error) return <p>Error: {error}</p>;

    return (
        <Layout>
            {setDetails && (
                <div className="set-listings-page">
                    <div className="set-details-container">
                        <div className="set-logo-container">
                            <img src={setDetails.logo_image} alt={setDetails.name} className="set-logo" />
                        </div>
                        <div className="set-info">
                            <div className="set-name">{setDetails.name}</div>
                            <div className="set-series">{setDetails.series}</div>
                            <div className="set-details">
                                <span className="set-release">Released: {new Date(setDetails.release_date).toLocaleDateString()}</span>
                                <span className="set-cards">Cards: {setDetails.total}</span>
                                {setDetails.ptcgo_code && <span className="set-code">PTCGO: {setDetails.ptcgo_code}</span>}
                            </div>
                        </div>
                        <div className="set-symbol-container">
                            <img src={setDetails.symbol_image} alt={`${setDetails.name} symbol`} className="set-symbol" />
                        </div>
                    </div>
                    <div className="listings-container">
                        <Binder listings={listings} />
                    </div>
                    <div className="pagination">
                        <button 
                            onClick={() => setPage(prev => Math.max(prev - 1, 1))} 
                            disabled={page === 1}
                        >
                            Previous
                        </button>
                        <span>Page {page}</span>
                        <button 
                            onClick={() => setPage(prev => prev + 1)} 
                            disabled={listings.length === 0}
                        >
                            Next
                        </button>
                    </div>
                </div>
            )}
        </Layout>
    );
};

export default SetListingsPage; 